module.exports = __webpack_public_path__ + "static/offerDetails.7897217b.svg";